import Reducer from '../Reducer.js';
const reducer = Reducer.reducer(null, 'USER');
export default reducer;